import { Grid } from '@mui/material';
import { getNodesAvailable } from 'lib/api/decisionEngine';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import {
  Node,
  RevisionObjective,
} from 'pages/Settings/Components/Risk/Components/DecisionEngines/components/Create/types';
import React from 'react';
import { useDispatch } from 'react-redux';

import LineNodesConfiguration from './Configuration';
import MatrixVisualization from './Visualization';

type Props = {
  decisionNodesAssignation: Node[];
  setDecisionNodesAssignation: (nodes: Node[]) => void;
  revisionObjective: RevisionObjective;
};

const MatrixEngine: React.FC<Props> = ({
  revisionObjective,
  decisionNodesAssignation,
  setDecisionNodesAssignation,
}) => {
  const dispatch = useDispatch();
  const { isPending } = getNodesAvailable(dispatch, revisionObjective);

  if (isPending) return <CenteredCircularProgress type="layout" />;

  return (
    <Grid container style={{ paddingTop: '20px' }}>
      <Grid item xs={4}>
        <LineNodesConfiguration
          revisionObjective={revisionObjective}
          decisionNodesAssignation={decisionNodesAssignation}
          setDecisionNodesAssignation={setDecisionNodesAssignation}
        />
      </Grid>
      <Grid item xs={8} style={{ overflowX: 'auto' }}>
        <MatrixVisualization
          nodes={decisionNodesAssignation}
          revisionObjective={revisionObjective}
        />
      </Grid>
    </Grid>
  );
};

export default MatrixEngine;
